<template>
  <div>
    <input
        placeholder="Huidig wachtwoord"
        type="password"
        class="text"
        v-model="currentPassword"
    />

    <ul class="error-message" v-if="currentErrorMessage.length">
      <li v-for="(error, index) in currentErrorMessage" :key="'current-' + index">
        {{ error }}
      </li>
    </ul>

    <input
        placeholder="Nieuw wachtwoord"
        type="password"
        class="text"
        v-model="newPassword"
    />

    <ul class="error-message" v-if="newErrorMessage.length">
      <li v-for="(error, index) in newErrorMessage" :key="'new-' + index">
        {{ error }}
      </li>
    </ul>

    <input
        placeholder="Herhaal nieuw wachtwoord"
        type="password"
        class="text"
        v-model="confirmPassword"
    />

    <ul class="error-message" v-if="confirmErrorMessage.length">
      <li v-for="(error, index) in confirmErrorMessage" :key="'confirm-' + index">
        {{ error }}
      </li>
    </ul>

    <div class="error-message" v-if="generalErrorMessage">
      {{ generalErrorMessage }}
    </div>

    <button class="submit btn wide" @click="changePasswordHandler">
      Wijzig wachtwoord
    </button>

    <div class="success" v-if="successMessage">
      {{ successMessage }}
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ChangePasswordForm",
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      currentErrorMessage: [],
      newErrorMessage: [],
      confirmErrorMessage: [],
      generalErrorMessage: "",
      successMessage: "",
    };
  },
  methods: {
    ...mapActions("user", ["changePassword"]),
    changePasswordHandler() {
      // Reset state
      this.currentErrorMessage = [];
      this.newErrorMessage = [];
      this.confirmErrorMessage = [];
      this.generalErrorMessage = "";
      this.successMessage = "";

      if (!this.currentPassword || !this.newPassword || !this.confirmPassword) {
        this.generalErrorMessage = "Vul alle velden in";
        return;
      }

      if (this.newPassword !== this.confirmPassword) {
        this.confirmErrorMessage = ["De nieuwe wachtwoorden komen niet overeen"];
        return;
      }

      if (this.newPassword.length < 8) {
        this.newErrorMessage = ["Het nieuwe wachtwoord moet minimaal 8 tekens lang zijn"];
        return;
      }

      const requestData = {
        current_password: this.currentPassword,
        password: this.newPassword,
        password_confirmation: this.confirmPassword,
      };

      this.changePassword(requestData)
          .then((response) => {
            // Check if server returned validation errors in a 200 OK
            if (
                response.incorrect_current ||
                response.password ||
                response.password_confirmation
            ) {
              if (response.incorrect_current) {
                this.currentErrorMessage = response.incorrect_current;
              }

              if (response.password) {
                this.newErrorMessage = response.password;
              }

              if (response.password_confirmation) {
                this.confirmErrorMessage = response.password_confirmation;
              }

              return;
            }

            // All good
            this.currentPassword = "";
            this.newPassword = "";
            this.confirmPassword = "";
            this.successMessage = "Wachtwoord gewijzigd";
          })
          .catch((err) => {
            if (!err.response || !err.response.data) {
              this.generalErrorMessage = "Er is iets foutgegaan. Controleer de ingevulde velden.";
              return;
            }

            const error = err.response.data;

            if (error.incorrect_current) {
              this.currentErrorMessage = error.incorrect_current;
            }

            if (error.password) {
              this.newErrorMessage = error.password;
            }

            if (error.password_confirmation) {
              this.confirmErrorMessage = error.password_confirmation;
            }
          });
    },
  },
};
</script>
